/* eslint-disable @typescript-eslint/ban-ts-comment */
import ChevronIcon from "@icons/chevronIcon.svg";
import classNames from "classnames";
import { ReactNode, useRef, useState } from "react";
import { Navigation } from "swiper/modules";
import { Swiper } from "swiper/react";
import styles from "./learningCarousel.module.scss";

export const LearningCarousel = (props: Props) => {
  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);
  const [slideActiveIndex, setSlideActiveIndex] = useState(0);

  return (
    <div className={styles["container"]}>
      <Swiper
        modules={[Navigation]}
        navigation={{
          nextEl: nextRef.current,
          prevEl: prevRef.current,
        }}
        onInit={(swiper) => {
          // @ts-ignore
          swiper.params.navigation.prevEl = prevRef.current;
          // @ts-ignore
          swiper.params.navigation.nextEl = nextRef.current;
          swiper.navigation.init();
          swiper.navigation.update();
        }}
        slidesPerView={!props.isMobile ? props.perView : "auto"}
        spaceBetween={props.spaceBetween}
        onSlideChange={(e) => setSlideActiveIndex(e.activeIndex)}
        className={styles["mobileSwiperContainer"]}
        preventInteractionOnTransition
      >
        {props.children}
        {props.swipeItemsLength > props.perView && !props.isMobile && (
          <>
            <div
              className={classNames(
                styles["prevButton"],
                slideActiveIndex <= 0 && styles["disabled"],
              )}
              ref={prevRef}
              data-testid="prev-button"
            >
              <ChevronIcon />
            </div>
            <div
              className={classNames(
                styles["nextButton"],
                slideActiveIndex + props.perView >= props.swipeItemsLength &&
                  styles["disabled"],
              )}
              ref={nextRef}
              data-testid="next-button"
            >
              <ChevronIcon />
            </div>
          </>
        )}
      </Swiper>
    </div>
  );
};

interface Props {
  children: ReactNode;
  swipeItemsLength: number;
  perView: number;
  spaceBetween: number;
  isMobile: boolean;
}
